import { Avatar, Box } from '@mui/material';
import { AccordionArrowBlue } from 'Images';

export const AccordionExpandIconBlue = () => {
  return (
    <Box sx={{ p: 1 }}>
      <Avatar
        src={AccordionArrowBlue}
        sx={{
          width: '20px',
          height: '20px',
        }}
        alt={''}
      />
    </Box>
  );
};
